// API Base Configuration
const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:5000';

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.token = null;
  }

  // Setzt den Bearer-Token für alle nachfolgenden Requests
  setToken(token) {
    this.token = token;
  }

  // Helper method for making requests
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    const authHeaders = this.token
      ? { Authorization: `Bearer ${this.token}` }
      : {};

    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
        ...options.headers,
      },
      ...options,
    };

    try {
      console.log(`🌐 API Request: ${options.method || 'GET'} ${url}`);
      if (options.body && typeof options.body === 'string') {
        console.log('📦 Request Body:', JSON.parse(options.body));
      }

      const response = await fetch(url, config);

      console.log(`📥 Response Status: ${response.status} ${response.statusText}`);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`❌ Response Error:`, errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }

      // Handle different response types
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const jsonData = await response.json();
        console.log(`✅ Response Data:`, jsonData);
        return jsonData;
      } else if (contentType && contentType.includes('image/')) {
        return response; // Return response for image handling
      } else {
        const textData = await response.text();
        console.log(`✅ Response Text:`, textData);
        return textData;
      }
    } catch (error) {
      console.error(`❌ API Error for ${endpoint}:`, error);
      console.error(`❌ Error details:`, {
        message: error.message,
        stack: error.stack,
        url: url,
        method: options.method || 'GET'
      });
      throw error;
    }
  }

  // GET request
  async get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  }

  // POST request
  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // POST with FormData (for file uploads)
  async postFormData(endpoint, formData) {
    const authHeaders = this.token
      ? { Authorization: `Bearer ${this.token}` }
      : {};
    return this.request(endpoint, {
      method: 'POST',
      headers: authHeaders, // Kein Content-Type, damit Browser multipart/form-data setzt
      body: formData,
    });
  }

  // PATCH request
  async patch(endpoint, data) {
    return this.request(endpoint, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  // GET image URL (for displaying images)
  getImageUrl(endpoint) {
    return `${this.baseURL}${endpoint}`;
  }

  // Holt ein Bild mit Bearer-Token und gibt eine Blob-URL zurück
  async fetchBlobUrl(endpoint) {
    const url = `${this.baseURL}${endpoint}`;
    const headers = this.token ? { Authorization: `Bearer ${this.token}` } : {};
    const response = await fetch(url, { headers });
    if (!response.ok) throw new Error(`Image fetch failed: ${response.status}`);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }
}

export default new ApiService();
